import { useContext } from 'react';
import * as Html from 'view-layer/styled/html';
import { InnerBox } from 'view-layer/components/layout/InnerBox';

import { GenericKeyValue } from 'business-layer/types';
import { L10nContext } from 'business-layer/contexts/L10nContext';
import { PropertyAmount } from 'view-layer/components/layout/info/PropertyAmount';
import { CustomerData } from 'view-layer/components/layout/info/CustomerData';

export const Header = ({ payment }: any): JSX.Element => {
  const { labels }: { labels: GenericKeyValue } = useContext(L10nContext) as any;

  return (
    <InnerBox pb={0}>
      <Html.H2 data-testid="header-header">{labels?.pageTitle}</Html.H2>
      <PropertyAmount
        label={'Balance Due'}
        currency={payment.currency}
        amount={payment.amount}
      />
      <CustomerData
        mt={5}
        firstName={payment.firstName}
        lastName={payment.lastName}
        reservationId={payment.reservationIdentifier}
      />
    </InnerBox>
  );
}
